// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","purpleDark":"#22214f","purple":"#302e79","pink":"#dc3371","yellow":"#f5b727","richText":"rich-text-module--rich-text--2u8qT"};